export default {
  meta: {
    label: 'Hindi (हिन्दी)'
  },
  data: {
    hi: {
      97: [['🍎', 'एप्पल'], ['👽', 'एलियन'], ['🦅', 'एडलर']],
      98: [['🍌', 'बनाना'], ['👶', 'बेबी']],
      99: [['🤡', 'क्लाउन']],
      100: [['🐬', 'डॉल्फिन']],
      101: [['🥚', 'एग'], '🦎', '🦄'],
      102: [['🐸', 'फ्रॉग'], '🍟', '👣'],
      103: [['👻', 'घोस्ट'], '🦍', '🎻'],
      104: [['🏒', 'हॉकी स्टिक'], '🐹', '🌺', '🐇'],
      105: [['🍦', 'आइस क्रीम']],
      106: [['🤹🏼‍♀️', 'जुग्गलर'], '👖'],
      107: [['🔪', 'नाइफ']],
      108: [['🦁', 'लायन'], '🐆'],
      109: [['🌝', 'मूत्र'], '🍈'],
      110: [['👃', 'नोज']],
      111: [['🐙', 'ऑक्टोपस'], '👌'],
      112: [['🥘', 'पॉट']],
      113: [['👸🏻', 'क्वीन']],
      114: ['🤖', '♻️', ['☂️', 'रेन']],
      115: [['🐍', 'स्नेक'], '🤳', '🥗'],
      116: ['🦃', ['🐯', 'टाइगर'], '🌮', '🐅'],
      117: [['☂️', 'अम्ब्रेला']],
      118: [['🏐', 'वॉलीबॉल']],
      119: [['🌊', 'वेव']],
      120: [],
      121: [['💴', 'एन'], '☯️'],
      122: [['⚡️', 'ज़ैप']]
    }
  }
};








